export default __webpack_public_path__ + "static/media/cubyts-to-figma.6b6ad28d.svg";